import { render, staticRenderFns } from "./CookieElement.vue?vue&type=template&id=c79aac2a"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {EditorImage: require('/home/node/app/node_modules/@gauss/cms-core/lib/components/editors/EditorImage.js').default,EditorTipTap: require('/home/node/app/node_modules/@gauss/cms-core/lib/components/editors/EditorTipTap.js').default,UiButtonComponent: require('/home/node/app/components/ui/buttonComponent.vue').default,ControllerCookie: require('/home/node/app/node_modules/@gauss/cms-core/lib/components/controllers/ControllerCookie.js').default})
